import { useEffect, useState } from "react"
import { NeoSecondaryButton } from "@neo/neo-common-ui/lib"
import { showToastr } from "../../app.constants"

type ExportCatalogProgressProps = {
  exportStatus: "pending" | "fulfilled" | "rejected"
  closePopup: () => void
  title?: string
}

const ExportProgress = ({
  exportStatus,
  closePopup,
  title = "Exporting"
}: ExportCatalogProgressProps) => {
  const [apiProgressStatus, setApiProgressStatus] = useState(0)

  useEffect(() => {
    let timeInterval
    if (exportStatus === "pending") {
      timeInterval = setInterval(() => {
        setApiProgressStatus((data) => {
          if (data > 90) {
            clearInterval(timeInterval)
            return data
          } else {
            return data + 1
          }
        })
      }, 500)
    } else if (exportStatus === "fulfilled") {
      clearInterval(timeInterval)
      setApiProgressStatus(100)
    } else if (exportStatus === "rejected") {
      const toastConfig = {
        type: "error",
        message: `Unable to export, please try again`
      }
      showToastr(toastConfig)
      clearInterval(timeInterval)
      setApiProgressStatus(100)
      closePopup()
    }
  }, [exportStatus])

  /**
   * UI Template
   */
  return (
    <div className="upload-popup-box">
      <div
        className="upload-popup-box-overlay"
        onClick={closePopup}
        onKeyDown={(e) => {}}
        role="button"
        tabIndex={0}
        aria-label="Close export progress"
      ></div>
      <div className="upload-popup-box-content">
        <div className="upload-popup-box-heading">
          <h2>{title}</h2>
        </div>
        <div className="upload-popup-box-body">
          <span className="uploaded-file-name">
            {exportStatus === "pending"
              ? "Export is in progress, please wait"
              : "Export completed"}
          </span>
          <div className="upload-popup-progress-bar mt-4 mb-4">
            <div
              className="upload-popup-progress-highlight"
              style={{ width: apiProgressStatus + "%" }}
            ></div>
            <div style={{ textAlign: "right", marginTop: "0.5rem" }}>
              {apiProgressStatus + "%"}
            </div>
          </div>
        </div>
        <div className="upload-popup-box-footer">
          <NeoSecondaryButton
            isDisabled={exportStatus === "pending"}
            onClick={() => {
              closePopup()
            }}
          >
            Ok
          </NeoSecondaryButton>
        </div>
      </div>
    </div>
  )
}

export default ExportProgress
